import { parseReportingChartDate } from '../userActivity/formatters';
import type { UserProfileActivity } from './types';

export interface LastSignInDisplay {
  iso: string;
  /** True when derived from the 7-day chart (day only), not an exact session timestamp. */
  dateOnly: boolean;
}

export function resolveLastSignInDisplay(activity: UserProfileActivity): LastSignInDisplay | null {
  const exact = parseLastSignInIso(activity.lastSignInAt);
  if (exact) return { iso: exact, dateOnly: false };

  for (let i = activity.dailySessionsLast7Days.length - 1; i >= 0; i--) {
    const day = activity.dailySessionsLast7Days[i];
    if (day.sessionCount > 0 && day.date) {
      const d = parseReportingChartDate(day.date);
      if (!Number.isNaN(d.getTime())) {
        return { iso: d.toISOString(), dateOnly: true };
      }
    }
  }

  return null;
}

export function formatLastSignInDisplay(signIn: LastSignInDisplay): string {
  const d = new Date(signIn.iso);
  if (Number.isNaN(d.getTime())) return '—';
  if (signIn.dateOnly) {
    return d.toLocaleDateString(undefined, { dateStyle: 'medium' });
  }
  return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

function parseLastSignInIso(raw: string | null | undefined): string | null {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return null;
    const d = new Date(trimmed);
    if (Number.isNaN(d.getTime())) return null;
    return d.toISOString();
  }
  return null;
}
